'use client';
import React, { forwardRef } from 'react';

import {
  NavigationMenu,
  StickyTopMenu,
} from '@wwe-portal/ui/components/navigation';

export interface StoreRevampNavigationProps {
  className?: string;
  onClick?: (item: { id: string; label: string }) => void;
  activeId: string | undefined;
  itemIds: {
    icon: React.ReactNode;
    id: string;
    label: string;
  }[];
}
export const StoreRevampNavigation = forwardRef<
  HTMLDivElement,
  StoreRevampNavigationProps
>(({ className, onClick, activeId, itemIds }, ref) => {
  return (
    <StickyTopMenu className={className} ref={ref}>
      <NavigationMenu
        activeId={activeId}
        className="gap-2.5 px-5 xl:px-[30px]"
        itemClassName="flex-1"
        items={itemIds}
        onClick={onClick}
      />
    </StickyTopMenu>
  );
});

StoreRevampNavigation.displayName = 'StoreRevampNavigation';
